// extracted by mini-css-extract-plugin
export default {"formWrapper":"company-detail-form_formWrapper__C-PLg","actionBtnWrapper":"company-detail-form_actionBtnWrapper__KSE6e","nextBtn":"company-detail-form_nextBtn__pyvfh"};